// if (document.body.classList.contains('body_sustainability')) {
//     console.log('body_sustainability = Y');
//
//     // Seleziona tutti i pulsanti
//     const buttons = document.querySelectorAll('.sustainability-tab-title');
//
//     // Aggiungi un event listener a ciascun pulsante
//     buttons.forEach(button => {
//         button.addEventListener('click', () => {
//             // Rimuovi la classe "active" da tutti i pulsanti
//             buttons.forEach(btn => btn.classList.remove('active'));
//
//             // Rimuovi la classe "active" da tutti i contenuti
//             const contents = document.querySelectorAll('.sustainability-tab-content');
//             contents.forEach(content => content.classList.remove('active'));
//
//             // Aggiungi la classe "active" al pulsante cliccato
//             button.classList.add('active');
//
//             // Ottieni il valore di data-tab-btn del pulsante cliccato
//             const tabId = button.getAttribute('data-tab-btn');
//
//             // Trova il contenuto corrispondente e aggiungi la classe "active"
//             const activeContent = document.querySelector(`.sustainability-tab-content[data-tab="${tabId}"]`);
//             if (activeContent) {
//                 activeContent.classList.add('active');
//             }
//         });
//     });
// } else {
//     console.log('body_sustainability = N');
// }








// if (document.body.classList.contains('body_sustainability')) {
//     console.log('body_sustainability = Y');
//
//     // Seleziona tutti i pulsanti
//     const buttons = document.querySelectorAll('.sustainability-tab-title');
//
//     // Aggiungi un event listener a ciascun pulsante
//     buttons.forEach(button => {
//         button.addEventListener('click', () => {
//             // Ottieni il valore di data-tab-btn del pulsante cliccato
//             const tabId = button.getAttribute('data-tab-btn');
//
//             // Seleziona tutti i pulsanti e contenuti correlati basandosi su data-tab-btn e data-tab
//             const relatedButtons = document.querySelectorAll(`.sustainability-tab-title[data-tab-btn]`);
//             const relatedContents = document.querySelectorAll(`.sustainability-tab-content[data-tab]`);
//
//             // Rimuovi la classe "active" da tutti i pulsanti correlati
//             relatedButtons.forEach(btn => btn.classList.remove('active'));
//
//             // Rimuovi la classe "active" da tutti i contenuti correlati
//             relatedContents.forEach(content => content.classList.remove('active'));
//
//             // Aggiungi la classe "active" al pulsante cliccato
//             button.classList.add('active');
//
//             // Trova tutti i contenuti con il data-tab corrispondente e aggiungi la classe "active"
//             relatedContents.forEach(content => {
//                 if (content.getAttribute('data-tab') === tabId) {
//                     content.classList.add('active');
//                 }
//             });
//         });
//     });
// } else {
//     console.log('body_sustainability = N');
// }





if (document.body.classList.contains('body_sustainability')) {
    console.log('body_sustainability = Y');

    // Seleziona tutti i pulsanti
    const buttons = document.querySelectorAll('.sustainability-tab-title');

    // Aggiungi un event listener a ciascun pulsante
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // Ottieni il valore di data-tab-btn del pulsante cliccato
            const tabId = button.getAttribute('data-tab-btn');

            // Seleziona tutti i pulsanti con qualsiasi data-tab-btn
            const allButtons = document.querySelectorAll('.sustainability-tab-title');

            // Seleziona tutti i contenuti con qualsiasi data-tab
            const allContents = document.querySelectorAll('.sustainability-tab-content');

            // Rimuovi la classe "active" da tutti i pulsanti
            allButtons.forEach(btn => btn.classList.remove('active'));

            // Rimuovi la classe "active" da tutti i contenuti
            allContents.forEach(content => content.classList.remove('active'));

            // Aggiungi la classe "active" a tutti i pulsanti con lo stesso data-tab-btn
            const relatedButtons = document.querySelectorAll(`.sustainability-tab-title[data-tab-btn="${tabId}"]`);
            relatedButtons.forEach(btn => btn.classList.add('active'));

            // Aggiungi la classe "active" a tutti i contenuti con lo stesso data-tab
            const relatedContents = document.querySelectorAll(`.sustainability-tab-content[data-tab="${tabId}"]`);
            relatedContents.forEach(content => content.classList.add('active'));
        });
    });
} else {
    console.log('body_sustainability = N');
}
